import React from 'react';
import { Routes, Route } from 'react-router-dom';
import DocsSidebar from '../components/DocsSidebar';
import Introduction from '../docs/Introduction';
import Modes from '../docs/Modes';
import ModesGestures from '../docs/ModesGestures';
import ModesBlinks from '../docs/ModesBlinks';
import Instructions from '../docs/Instructions';
import Traingestures from '../docs/TrainGestures';
import Mouse from '../docs/Mouse';
import Blinks from '../docs/Blinks';
import './Docs.css';
import { Helmet } from 'react-helmet';

const Docs = () => {
  return (
    <div className="docs-container">
      <Helmet>
        <title>FaceLead - Documentation</title>
        <meta name="description" content="Find out how to set-up and get the most from FaceLead" />
      </Helmet>
      <DocsSidebar />
      <div className="docs-content">
        <Routes>
          <Route path="introduction" element={<Introduction />} />
          <Route path="modes" element={<Modes />} />
          <Route path="modes/gestures" element={<ModesGestures />} />
          <Route path="modes/blinks" element={<ModesBlinks />} />
          <Route path="instructions" element={<Instructions />} />
          <Route path="traingestures" element={<Traingestures />} />
          <Route path="mouse" element={<Mouse />} />
          <Route path="blinks" element={<Blinks />} />
        </Routes>
      </div>
    </div>
  );
};

export default Docs;
